import React, { Component, useState } from "react";
import OtpInput from "react-otp-input";
import { Form, Button, Carousel, CarouselItem, Modal } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
function Example() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export function HeaderIntro() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // render() {
  return (
    <div>
      <section id="intro" class="clearfix carousel">
        <div className="intro-info1">
          <div class="container" data-aos="fade-up">
            <div class="intro-img" data-aos="zoom-out" data-aos-delay="200">
              <h4
                style={{
                  color: "#fff",
                  alignContent: "center",
                  fontSize: 32,
                  justifyContent: "center",
                  alignSelf: "center",
                  fontWeight: 500,
                }}
              >
                Wish to speak to our Expert?
                <br />{" "}
              </h4>
              <p
                style={{
                  color: "#fff",
                  alignContent: "center",
                  fontSize: 14,
                  justifyContent: "center",
                  alignSelf: "center",
                  fontWeight: 500,
                }}
              >
                Please share your details. We assure to get back to you on
                priority.
              </p>
              {/* <OtpInput
                  value={this.state.otp}
                  onChange={this.handleChange}
                  numInputs={4}
                  separator={<span>-</span>}
                /> */}

              {/* <Button variant="primary" onClick={handleShow}>
                Launch demo modal
              </Button> */}

              <Modal size="sm" show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                  <Modal.Title>OTP</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <OtpInput numInputs={4} separator={<span>---</span>} />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Resend
                  </Button>
                  <Button variant="primary" onClick={handleClose}>
                    Submit
                  </Button>
                </Modal.Footer>
              </Modal>
              <form>
                <div class="row">
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control form-control-md"
                      placeholder="Full Name"
                      name="name"
                      // onChange={this.onChange}
                      style={{ color: "#004767" }}
                    />
                  </div>
                </div>
                <br />
                <div class="row">
                  <div className="col-sm-10">
                    {/* <input
                      type="number"
                      className="form-control form-control-md"
                      placeholder="Mobile Number"
                      name="mobilenumber"
                      // onChange={this.onChange}
                      style={{color:"#004767"}}
                    /> */}

                    <PhoneInput
                      className="col-sm-4"
                      country={"in"}
                      inputStyle={{ color: "#004767" }}
                      containerStyle={{ margin: "20px" }}
                      buttonStyle={{}}
                     
                      // value={this.state.phone}
                      // onChange={(phone) => this.setState({ phone })}
                      style={{ color: "#004767" }}
                    />
                  </div>
                </div>
                <br />
                <div class="row">
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control form-control-md"
                      placeholder="Email Id"
                      name="emailid"
                      // onChange={this.onChange}
                      style={{ color: "#004767" }}
                    />
                  </div>
                </div>
                <br />

                <div class="row">
                  <div className="col-sm-10">
                    <select
                      name="classid"
                      className="form-control form-control-md"
                      // onChange={this.onChange}
                      style={{ color: "#004767" }}
                    >
                      <option>Choose From Our Services</option>
                      <option>Incometax E-Filing</option>
                      <option>GST Services</option>
                      <option>Company Secreterial Services</option>
                      <option>Investment Services</option>
                      <option>Loan</option>
                    </select>
                  </div>
                </div>
                <br />
                {/* <button
                  variant="primary"
                  
                  className="col-sm-10 btn "
                  style={{ backgroundColor: "#004767", color: "#fff" }}
                  onClick={handleShow}
                >
                  Submit
                </button> */}
                <Button
                  variant="primary"
                  className="col-sm-10 btn "
                  // style={{ backgroundColor: "#004767", color: "#fff"  }}
                  // onClick={handleShow}
                >
                  {" "}
                  Submit{" "}
                </Button>
              </form>
            </div>

            <div class="intro-info" data-aos="zoom-in" data-aos-delay="100">
              <h2>
                Avail Our Expertise
                <br />
                For Your Taxation and
                <br />
                Financial Requirements
              </h2>
              <div>
                {/* <a href="#about" class="btn-get-started scrollto">
                    Get Started
                  </a> */}
                <a href="#services" class="btn-services scrollto">
                  Services Start as low as ₹49
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
// }

export default HeaderIntro;
